import styles from "@/styles/hero.module.scss";

const BasicHero = ({ data }) => {
  const bg =
    data.heroBackground === "white"
      ? "bg-white"
      : data.heroBackground === "grey"
      ? "bg-onmoLightGrey"
      : styles.basicBg;
  return (
    <div className={`flex justify-center items-center min-h-[254px] ${bg}`}>
      <h1 className={styles.basicTitle}>{data.title}</h1>
    </div>
  );
};

export default BasicHero;
